module.exports = __webpack_public_path__ + "img/icon-advantage-4.84b60bf3.png";